import { AnyAction } from 'redux';

const initialState = {};
function taskReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    default:
      return state;
  }
}

export default taskReducer;
